import {
  MdAltRoute,
  MdApartment,
  MdCategory,
  MdFlag,
  MdPark,
  MdPlace,
  MdTerrain,
  MdTextFields,
  MdWaterDrop,
} from "react-icons/md";
import type { ComponentId } from "../../libs/simple/types";

const ICONS: { [id in ComponentId]: typeof MdTerrain } = {
  land: MdTerrain,
  water: MdWaterDrop,
  landuse: MdPark,
  roads: MdAltRoute,
  buildings: MdApartment,
  borders: MdFlag,
  labels: MdTextFields,
  pois: MdPlace,
  other: MdCategory,
};

// A grey symbol for a part of the map. Deliberately colourless: in this
// panel only the swatches carry colour. Decorative, the name sits next to it.
export default function ComponentIcon(props: { id: ComponentId }) {
  const Icon = ICONS[props.id];
  return (
    <span className="studio-component-icon" aria-hidden="true">
      <Icon />
    </span>
  );
}
